export default class OffCanvas {
  constructor() {
    const bodyElement = document.getElementsByTagName('body')[0];

    // TOGGLE OFF CANVAS
    const navbarToggle = document.querySelector('.nav-toggle');
    const viewport = document.querySelector('.viewport');
    const pageOverlay = document.querySelector('.page-overlay');
    const desktopMenu = document.getElementById('nav');
    navbarToggle.addEventListener('click', (e) => {
      bodyElement.classList.add('nav-open');
      viewport.appendChild(desktopMenu);
      e.preventDefault();
    });

    if (pageOverlay) {
      pageOverlay.addEventListener('click', () => {
        bodyElement.classList.remove('nav-open');
        viewport.removeChild(desktopMenu);
      });
    }
  }
}
